<script>
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";
export default {
  mixins: [kenwoodItalyBasicMixin],
  props: ["content", "width"],
  data() {
    return {
    };
  },
  methods: {
    alignTextToJustify: Fandom.alignTextToJustify
  },
  computed: { }
};
</script>

<template>
  <div class="container py-sm-4 py-3" stripe-header>
    <div class="row" :class="`justify-content-md-${alignTextToJustify(content.text_align)}`">
      <div :class="[`text-${content.text_align || 'center'}`, `col-sm-${width || 8}`, {'mx-auto': !content.text_align}]">
        <div class="d-flex justify-content-center">
          <span class="text-uppercase px-2 py-1 font-sm d-flex text-white mb-3" :class="`bg-${color}`" v-if="content.category">
            {{content.category}}
          </span>
        </div>
        <component class="title-composed" :is="content.title_tag || 'h2'" v-if="content.title && !content.title_composed">
          {{content.title}}
        </component>
        <component class="title-composed" :is="content.title_tag || 'h2'" v-else>
          <span v-for="(title, index) in content.title_composed" :key="`title-${index}`" :class="getTitleStyle(title)">
            {{title.title}}
          </span>
        </component>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// TODO: remove this style becouse copyed into text.css to share with two col stripe layout
[stripe-header] {

  .title-composed {
    .title-italic {
      font-style: italic;
    }
    .title-uppercase {
      text-transform: uppercase;
    }
    .title-underline {
      text-decoration: underline;
    }
    .title-block {
      display: block;
    }
    .title-new-line {
      &::after{
        content: "\a";
        white-space: pre;
      }
    }
  }

  .favourite {
    i {
      font-size: 1.75rem;
    }
  }

}
</style>